// tslint:disable
/**
 * CONEXSYS Resource Portal API
 * The API for the CONEXSYS Resource Portal
 *
 * The version of the OpenAPI document: 2.0.0
 * Resource: support@conexsys.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { virtualConfig as config } from '../../../config/virtual';
import { apiRequest, setEntitiesApiOperationState } from '../../../app/api';
import { ResourceHelper } from '../classes';
import moment from 'moment';
import _ from 'lodash';

import { ResourceEntities } from '../collections';
import { State_ApiOperationContextTypes } from '../../../storage';
import { UseCtx } from '../../../config/hooks';

export enum ResourceApiOperation {
	readResources = 'readResources'
}

export interface ReadResourcesRequest {
	eventId: string;
	modifiedFrom?: string;
	ids?: string[];
	queryLimit?: number;
	queryBookmark?: string;
}

/**
 * Read resources
 */
export async function readResources(
	ctx: UseCtx<any>,
	requestParameters: ReadResourcesRequest
): Promise<ResourceEntities> {
	const operationId = ResourceApiOperation.readResources;

	// get the attempt date now BEFORE the request is made so there is no GAP in time if the request takes awhile or fails
	const attemptDate: string = moment().toISOString();

	// make the api request
	const response = await apiRequest<ResourceEntities, ReadResourcesRequest>(
		ctx,
		config.apiId,
		operationId,
		requestParameters
	);

	let entities: ResourceEntities | undefined = response.response.data;
	if (!entities) entities = [];

	if (entities.length > 0) {
		// set each entity.__state.eventId to the eventId from the params
		entities.forEach((entity, i, a) => {
			a[i].__state = _.merge(entity.__state || {}, {
				eventId: requestParameters.eventId
			});
		});

		// patch entities with an api success data for the operation
		setEntitiesApiOperationState<ResourceEntities, ResourceHelper>(
			ctx.virtual.resource,
			entities,
			operationId,
			State_ApiOperationContextTypes.Success,
			attemptDate
		);
		// upsert the entities to the store
		ctx.virtual.resource.upsert(entities);
	}

	// return the entities to the caller for direct reference
	return entities;
}
